import { fontSize } from "suneditor/src/plugins"

const styles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    width: '640px',
    justifySelf:"center",
    marginTop:16,
    paddingBottom:32
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  cardTitle: {
    fontSize: '20px',
    fontWeight: 500,
    marginBottom: '20px',
    textAlign: 'center',
  },
  fileContaienr:{
    display: "flex",
    gap: 4,
    flexDirection: "column",
    alignItems: "end"
  },
  limitWarningContainer:{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      paddingBottom: '60px',
  },
  creditText: {
    fontSize:13,
    textAlign: "center",
    color: theme.palette.secondary.light,
  }
})

export default styles
